module.exports = __webpack_public_path__ + "img/4.11477da4.gif";